import * as React from 'react';
import { EmptyState } from '@/components/custom/empty-state';
import { NotesCard } from './notes-card';
import { NotesEditor } from './notes-editor';
import { useTranslation } from 'react-i18next';
import { NotesAside, NotesBody, NotesNav, NotesView } from './notes';
import { FormField } from '../form';

export function NotesImportant(props) {
  const { setSearchTerm, notes, searchTerm, activeNote, setActiveNote } = props;
  const { t } = useTranslation();

  const filterNotes = notes => {
    let filteredNotes = notes;

    if (searchTerm !== '') {
      filteredNotes = filteredNotes.filter(a => a.title != null && a.title.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    return filteredNotes;
  };

  const filteredNotes = filterNotes(notes);

  const hasImportant = filteredNotes.length > 0;

  if (!hasImportant)
    return (
      <EmptyState
        type="register"
        title={'Você ainda não tem anotações importantes'}
        text={'Quando você marcar uma anotação como importante, ela aparecerá aqui'}
        variant="plain"
      />
    );

  return (
    <NotesBody>
      <NotesAside>
        <FormField
          aria-label={'Pesquisar'}
          placeholder={t('textsCommon.research')}
          type="search"
          name="search"
          onChange={e => setSearchTerm(e.target.value)}
        />
        <NotesNav>
          {filteredNotes.map(note => (
            <NotesCard
              note={note}
              index={note.id}
              key={note.id}
              activeNote={activeNote}
              setActiveNote={setActiveNote}
              user={{ image: note.user.image.url, name: note.user.name, id: note.user.id }}
            />
          ))}
        </NotesNav>
      </NotesAside>

      <NotesView>
        <NotesEditor
          note={activeNote}
          emptyStateTitle={t('emptyState.titleImportantNotes')}
          emptyStateText="Aqui estão as anotações que você marcou como importante. Clique para acessar."
        />
      </NotesView>
    </NotesBody>
  );
}
